<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_contents" id="top_btn"></a>
    <div class="privacy_area">
      <div class="Title">
        <h4>개인정보 처리방침</h4>
        <p>
          '페럼인프라 주식회사’는 (이하 ‘회사는’ 이라 합니다.) 귀하(사)의
          개인정보를 중요시하며, “정보통신망 이용촉진 및 정보보호”상의
          개인정보보호규정 및 대한민국의 관계법령을 준수하고 있습니다. 회사는
          개인정보 취급방침을 통하여 귀하(사)께서 제공하시는 개인정보가 어떠한
          용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가
          취해지고 있는지 알려드립니다.
        </p>
      </div>
      <div class="Text_area">
        <div class="Text">
          <h5>1. 개인정보 수집에 대한 동의</h5>
          <p>
            회사는 귀하(사)께서 개인정보 이용약관의 내용에 대해 “동의한다” 또는
            “동의하지 않는다” 버튼을 클릭할 수 있는 절차를 마련하였으며,
            귀하(사)께서는 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우
            일부 서비스의 이용이 제한 될 수 있습니다.
          </p>
        </div>

        <div class="Text">
          <h5>2. 수집하는 개인정보 항목</h5>
          <h6>
            회사는 사이버신문고 및 고객센터 이용을 위해 아래와 같은 개인정보를
            수집하고 있습니다.
          </h6>
          <ul>
            <li>
              - 개인정보 수집항목 : 이름, 비밀번호, 휴대전화번호, 전자메일,
              서비스 이용기록, 접속 IT 정보
              <br />- 개인정보 수집방법: 홈페이지(사이버신문고, 고객센터)
            </li>
          </ul>
        </div>

        <div class="Text">
          <h5>3. 개인정보의 수집 및 이용목적</h5>
          <h6>회사는 수집한 개인정보를 다음의 목적을 위하여 활용합니다.</h6>
          <ul>
            <li>
              - 이용목적 : 회원관리
              <br />- 개인식별, 고충 및 민원처리, 문의사항 응대, 공지 및 고지사항 개시
            </li>
          </ul>
        </div>

        <div class="Text">
          <h5>4. 개인정보 보유 및 이용기간</h5>
          <h6>
            원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를
            지체 없이 파기합니다.
            <br />단, 다음의 정보에 대하여 하기 사유로 명시한 기간까지 보존합니다.
          </h6>
          <ul>
            <li>
              - 보존항목 : 이름, 비밀번호, 휴대전화번호, 전자메일, 서비스
              이용기록, 접속 IP 정보
              <br />- 보존근거 : 홈페이지 관리규정
              <br />- 보존기간 : 3개월
            </li>
          </ul>
        </div>

        <div class="Text">
          <h5>5. 개인정보 파기절차 및 방법</h5>
          <h6>
            회사는 원칙적으로 개인정보 수집 및 이용목적의 달성 된 후 해당 정보를
            지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          </h6>
          <ul>
            <li>
              - 파기절차
              <span>
                귀하(사)께서 제보 등을 위해 입력하신 정보는 목적이 달성된 후
                별도의 Data Base로 옮겨져 (서면의 경우 별도의 서류함) 내부 방침
                및 기타 관련 법령에 의한 정 보보호 사유에 따라 (보유 및 이용기간
                참조) 일정 기간 저장된 후 파기합니다. 별도 Data Base로 옮겨진
                개인정보는 법률에 의한 경우가 아니고서는 보유 외 다른 목적으로
                이용되지 않습니다.
              </span>
            </li>
            <li>
              - 파기방법
              <span>
                전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
                기술적 방법을 사용하여 삭제합니다.
                <br />서면의 경우 개인정보 관리 책임자 또는 사이버신문고 담담직원의
                입회 하에 파쇄절차를 거쳐 내용을 알아 볼 수 없게끔
                파기합니다.
              </span>
            </li>
          </ul>
        </div>

        <div class="Text">
          <h5>6. 개인정보 제공</h5>
          <h6>회사는 귀하(사)의 개인정보를 원칙적으로 외부에 공개하지 않습니다.</h6>
          <ul>
            <li>단, 아래의 경우에는 예외로 합니다.</li>
            <li>
              1. 귀하(사)께서 사전에 동의한 경우
              <br />2. 법령에 의거하거나, 수사목적으로 법령에 정해진 절차와 방법에
              따라 수사기관의 요구가 있는 경우
            </li>
          </ul>
        </div>

        <div class="Text">
          <h5>7. 수집한 개인정보의 위탁</h5>
          <p>
            회사는 귀하(사)의 동의 없이 귀하(사)의 정보를 외부업체에 위탁하지
            않습니다. 향후 그러할 필요가 생길 경우, 위탁대상자와 위탁 업무
            내용에 대하여 귀하(사)께 통지 하고 필요한 경우 사전 동의를 받도록
            하겠습니다.
          </p>
        </div>

        <div class="Text">
          <h5>8. 이용자 및 법정 대리인의 권리와 그 행사 방법</h5>
          <p>
            이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만
            14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 파기를
            요청할 수 있습니다.
            <br />이용자 혹은 만 14세 미만 아동의 개인정보 조회수정 및 파기를 위해서는
            개인정보관리책임자에게 서면, 전화 또는 전자메일로 연락하시면 지체
            없이 조치하겠습니다.
            <br />귀하(사)가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을
            완료하기 전까지는 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
            잘못된 개인정보를 제 3자에게 이미 제공한 경우에는 정정 처리결과를 제
            3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
          </p>
        </div>

        <div class="Text">
          <h5>9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h5>
          <p>
            회사는 쿠키 등 인터넷 서비스 이용 시 자동 생성되는 개인정보를
            수집하는 장치를 운영하지 않습니다.
          </p>
        </div>

        <div class="Text">
          <h5>10. 개인정보관리책임자 및 의견수렴/불만처리</h5>
          <h6>귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 페럼인프라 홈페이지는 개인정보관리담당자를 두어 귀하의 개인정보를 관리하고 있으며 개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 개설하고 있습니다. 귀하의 개인정보와 관련한 문의사항 및 불만 사항이 있으시면 아래의 개인정보관리담당자에게 연락 주시면 즉시 조치하여 처리결과를 통보하겠습니다.</h6>
          <ul>
            <li>
              [개인정보보호 책임자]
              <br />- 성명 : 이상헌
              <br />- 소속 : 기획관리팀
              <br />- 직책 : 팀장
              <br />- 전자메일 : sanghun21c.lee@dongkuk.com
            </li>
          </ul>
          <p>
            귀하(사)께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호
            관련 민원을 개인정보 관리책임자 혹은 담당부서로 신고하실 수
            있습니다.
            <br />회사는 귀하(사)의 신고사항에 대해 신속하고 충분한 답변을 드릴 것을
            약속 드립니다.
            <br />기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
            문의하시기 바랍니다.
          </p>
          <p>
            1. 국민권익위원회 개인정보보호위원회 (sgeum@korea.kr /
            044-200-7130)
            <br />2. 정보보호 마크인증위원회 (www.eprivacy.or.kr / 02-550-9531~2)
            <br />3. 대검찰청 사이버수사과 (www.spo.go.kr / 1301)
            <br />4. 경찰청 사이버안전국 (cyberbureau.police.go.kr / 182)
            <br />5. 개인정보 분쟁조정위원회 (www.kopico.go.kr / 1833-6972)
            <br />6. 개인정보 침해신고센터 (privacy.kisa.or.kr / 118)
          </p>
        </div>

        <div class="Text">
          <h5>11. 개인정보에 관한 민원 서비스</h5>
          <p>
            본 개인정보 취급방침은 2010년 10월 1일에 제정되었으며, 2020. 2. 3.
            개정되었습니다.
            <br />법령/정책 또는 보안기술의 변경에 따라 내용의 추가/삭제 및 수정이
            있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전 회사
            홈페이지를 통해 변경사유 및 내용을 공지하도록 하겠습니다.
          </p>
          <ul>
            <li>
              - 개인정보취급방침 버전번호 : v1.2
              <br />- 개인정보취급방침 시행일자 : 2020. 02. 03.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "PersonalPolicy.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/footer/PersonalPolicy.vue